import { writable, get } from "svelte/store";
import { LocalStorage } from "../../services/LocalStorage";

let Preference = {
    positionPanelRight: true,
    openOnEveryPage: false,
    hideHighlighterButton: false,
    addCardsToTheBottom: false,
    betaFeatures: false,
    showAllHighlights: true,
    openInboxOnStartup: false,
    openByUrlOnStartup: false,
    focusBookmarkOnStartup: false,
};

export const PreferencesStore = writable(Preference);

/**
 * This is primarly a store so that there's no flickering when loading
 * CW panel (default is left but preference could set it to right) so
 * the CW panel is only shown after the preference for the position is
 * loaded
 */
export const PreferencesStoreInitialized = writable(false);

// initialize store from storage
LocalStorage.get("preferences").then((preferences) => {
    if (preferences) {
        // when new preference is added without this it would be overwritten
        // by the local copy
        for (const property in preferences) {
            Preference[property] = preferences[property];
        }

        PreferencesStore.set(Preference);
    }

    PreferencesStoreInitialized.set(true);
});

// subscribe local storage
PreferencesStore.subscribe((value) => {
    if (get(PreferencesStoreInitialized)) {
        LocalStorage.set("preferences", value).then((preferences) => {});
    }
});
